import { render, staticRenderFns } from "./entityDetails.vue?vue&type=template&id=1f55a137&scoped=true&"
import script from "./entityDetails.vue?vue&type=script&lang=js&"
export * from "./entityDetails.vue?vue&type=script&lang=js&"
import style0 from "./entityDetails.vue?vue&type=style&index=0&id=1f55a137&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55a137",
  null
  
)

export default component.exports